import {scaffolderPlugin} from '@backstage/plugin-scaffolder';
import {createScaffolderFieldExtension} from '@backstage/plugin-scaffolder-react';
import {FormFieldBlueprint, createFormField} from '@backstage/plugin-scaffolder-react/alpha';
import {BitbucketRepoNameField} from './BitbucketRepoNameField';
import {schema} from './schema';

const bitbucketRepoNameFormField = createFormField({
  name: 'BitbucketRepoNameExtension',
  component: BitbucketRepoNameField as any,
  schema: schema as any,
});

export const BitbucketRepoNameExtension = scaffolderPlugin.provide(
  createScaffolderFieldExtension({
    name: 'BitbucketRepoNameExtension',
    component: BitbucketRepoNameField,
    schema,
  }),
);

export const bitbucketRepoNameFieldExtension = FormFieldBlueprint.make({
  name: 'bitbucket-repo-name-extension',
  params: {
    field: async () => bitbucketRepoNameFormField,
  },
});
